import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { Form } from 'antd'
import { FaEdit } from "react-icons/fa"
import { useOutletContext } from 'react-router-dom'

import useCommonAPI from 'Shared/API/Common'
import AddDeviceForm from '../components/AddDeviceForm'

import DataTable from 'Shared/Components/DataTable'
import PopupModal from 'Shared/Components/PopupModal'
import { Dropdown, FormContainer } from 'Shared/Components/FormComponents'
import { showSuccess } from 'Shared/Components/NotifyToast'
import useSmartwatchAPI from 'Shared/API/Smartwatch'
import { IoAddCircleOutline } from 'react-icons/io5'

const SmartwatchConfinedSpaceDevices = () => {
  const { role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const [form] = Form.useForm()

  const [data, setData] = useState([])
  const [workers, setWorkers] = useState([])
  const [formOpen, setFormOpen] = useState({ "device": null, "isOpen": false })
  // const [addDeviceformOpen, setAddDeviceFormOpen] = useState(false)

  const tableRef = useRef()

  const filterRef = useRef({
    "search": ""
  })

  const { getWorkers } = useCommonAPI()
  const { getDevices, updateWorkerAssignment } = useSmartwatchAPI()

  const loadData = async () => {
    tableRef.current.setTableLoading(true)

    const body = await getDevices({
      type: "confined_space",
      search: filterRef.current.search,
      offset: (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
      limit: tableRef.current.getState()["itemsPerPage"]
    })

    body && setData({
      "data": body["data"],
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })

    tableRef.current.setTableLoading(false)
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        loadData()
      ])

      setPageLoading(false)
    }

    init()    
  }, [])

  const onFinish = async (values) => {
    setPageLoading(true)

    const res = await updateWorkerAssignment({"device_id": formOpen["device"], "worker_id": values["worker_id"]})

    if (res != null) {
      toggleForm()
      showSuccess(t("general_success"))

      loadData()
    }

    setPageLoading(false)
  }

  const toggleForm = async (row) => {
    if (!formOpen["isOpen"]) {
      setPageLoading(true)

      const w = await getWorkers()
      setWorkers(w["data"])

      form.setFieldsValue({
        "worker_id": row["worker_id"]
      })

      setPageLoading(false)
    }
    else{
      form.resetFields()
    }
    
    setFormOpen({
      "device": row ? row["device_id"] : null,
      "isOpen": !formOpen["isOpen"]
    })
  }

  const onSearch = async (value) => {    
    filterRef.current.search = value

    await loadData()
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ display: "flex", flexFlow: "column", height: "100%" }}>
            <DataTable
              data={data["data"]} count={data["count"]} loadData={() => loadData()} onSearch={onSearch} searchPlaceHolder={t("smartwatch_searchDevice")} ref={tableRef}
              columns={{
                "device_id": { "label": t("smartwatch_deviceId"), "sorting": false, "nowrap": true },
                "model": { "label": t("smartwatch_model"), "sorting": false, "nowrap": true },
                "worker_name": { "label": t("smartwatch_worker"), "sorting": false, "nowrap": true },
              }}
              // appActions={() => { return [
              //   ["admin"].includes(role) && {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { setAddDeviceFormOpen(true) }}
              // ]}}
              renderActions={(row) => { return [
                ["pm", "admin"].includes(role) && {icon: <FaEdit size={20}/>, text: "Edit", onClick: function(row) { toggleForm(row) }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <PopupModal isOpen={formOpen["isOpen"]} close toggle={() => toggleForm()} width="80%">
      <FormContainer form={form} onFinish={onFinish} initialValues={{ "worker_id": "" }}>
        <Dropdown field_name={t("smartwatch_worker")} field_id="worker_id" props={{ "options": workers.map((i) => ({ "value": i["worker_id"], "label": i["worker_name"] })) }}/>
      </FormContainer>
    </PopupModal>

    {/* <AddDeviceForm isOpen={addDeviceformOpen} device_type="confined_space" loadData={loadData} onClose={() => setAddDeviceFormOpen(false)}/> */}
  </>)
}

export default SmartwatchConfinedSpaceDevices
